import { ProductAvailabilityApi } from '../types/api/product-availability-api';
import { Method, callAxios } from '../axios';
import { buildURL } from '../common';

export const productAvailabilityApiFetchers = {
  getProductAvailabilityFetcher: async ({
    apcHost,
    params,
  }: {
    apcHost: string;
    params: ProductAvailabilityApi.GetProductAvailabilityParams;
  }) => {
    const GET_PRODUCT_AVAILABILITY_URL = process.env.REACT_APP_DEV === 'mock'
      ? 'http://localhost:3100/get-product-availability'
      : buildURL({
        host: process.env.API_HOST,
        contextRoot: apcHost,
        endpoint:
              '/rest/model/schneider/catalog/availability/rest/ProductAvailabilityActor/pdpProductAvailabilityInfo',
      });

    const response = await callAxios<{
      response: ProductAvailabilityApi.ProductAvailabilityResponse;
    }>({
      method: Method.GET,
      url: GET_PRODUCT_AVAILABILITY_URL,
      params,
    });

    return response.data;
  },
};
